Namespace 'Customer.Dashboard'

class Customer.Dashboard.SessionAboutToExpireView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/session_about_to_expire']

  events:
    'click #refresh-customer-session': 'refreshCustomerSession'

  initialize: (@options = {}) ->
    @customerSession = @options.customerSession
    @timeTillExpiration = @options.timeTillExpiration
    counter = new Customer.Sessions.SessionExpirationCounter(@timeTillExpiration)
    @counter_view = new Customer.Dashboard.SessionExpirationCounterView({model: counter})
    @listenTo(counter, 'customerSession:counter:finished', @disableContinueOperating)

  render:()->
    @$el.html(@template())
    @$el.find('#expiration-counter-container').html(@counter_view.render().el)
    @$el.find('#session-about-to-expire').modal()
    @

  refreshCustomerSession:()->
    @hide()
    Backbone.trigger 'customerSession:keepAlive'
    Backbone.trigger 'customerSession:updateBackEndLastAcivityTimestamp'

  hide:()->
    $('.modal-backdrop').remove()
    @$el.find('#session-about-to-expire').modal('hide')

  disableContinueOperating:()->
    @$el.find('#refresh-customer-session').prop('disabled', true)
